import { QueryParamsModel } from "app/core/_base/crud/models/query-models/query-params.model";
import { FileAttachment } from "../../danh-muc/fshare/fshare.model"

export const name_module = 'QA/QC';
export const name_page = 'Yêu cầu mua tài liệu';
export const url_page = '/qltl-yeu-cau-mua';

// CONST URL
export const url_create = 'them-moi';
export const url_edit = 'chinh-sua';
export const url_accept = 'duyet';
export const url_detail = 'chi-tiet';
export const url_confirm_buy = 'xac-nhan-mua';
export const url_confirm_update = 'xac-nhan-update';

// CONST NAME
export const name_create = 'Thêm mới yêu cầu mua tài liệu';
export const name_edit = 'Chỉnh sửa yêu cầu mua tài liệu';
export const name_accept = 'Duyệt yêu cầu mua tài liệu';
export const name_detail = 'Chi tiết yêu cầu mua tài liệu';
export const name_confirm_buy = 'Xác nhận mua tài liệu';
export const name_confirm_update = 'Xác nhận cập nhật tài liệu đã mua';

// CONST FORM
const PAGE_DEFAULT = 0;
const NUMBER_RECORD = 10;
export const query_init = new QueryParamsModel({}, 'asc', '', PAGE_DEFAULT, NUMBER_RECORD, {}, true);

// CONST BUTTON
export const BTN_BACK = {text: "Trở lại", color: "white"};
export const BTN_CONFIRM_UPDATE = {text: "Xác nhận cập nhật", color: "primary"};
export const BTN_CONFIRM_BUY = {text: "Xác nhận mua tài liệu", color: "primary"};
export const BTN_ACCEPT = {text: "Duyệt", color: "primary"};
export const BTN_REJECT = {text: "Không duyệt", color: "warn"};
export const BTN_OPEN_DOCUMENT = {text: "Danh sách<br>tài liệu", color: "accent"};
export const BTN_ADD_DOCUMENT = {text: "Thêm tài liệu", color: "primary"};

// CONST % THUẾ
export const tax_percentage = [{text : 'Không thuế', value : -1}, {text : '0', value : 0}, {text : '5', value : 5}, {text : '10', value : 10}]

export const ColumnsListDocumentInSystem = [
    {
        stt: 1,
		name: '#',
		displayName: '#',
		alwaysChecked: true,
		isShow: true
    },
    {
        stt: 2,
		name: 'CODE',
		displayName: 'MÃ TÀI LIỆU',
		alwaysChecked: true,
		isShow: true
    },
    {
        stt: 3,
		name: 'NAME',
		displayName: 'TÊN TÀI LIỆU',
		alwaysChecked: true,
		isShow: true
    },
    {
        stt: 4,
		name: 'AUTHOR',
		displayName: 'TÁC GIẢ',
		alwaysChecked: true,
		isShow: true
    },
    {
        stt: 4,
		name: 'DATE',
		displayName: 'NGÀY BAN HÀNH',
		alwaysChecked: true,
		isShow: true
    },
    {
        stt: 5,
		name: 'STATUS',
		displayName: 'TÌNH TRẠNG',
		alwaysChecked: true,
		isShow: true
    },
    {
        stt: 6,
		name: 'FILE',
		displayName: 'FILE',
		alwaysChecked: true,
		isShow: true
    },
]

export const ColumnsListRequiredToBuy = [
	{
		stt: 1,
		name: '#',
		displayName: '#',
		alwaysChecked: false,
		isShow: true
	},
	{
		stt: 2,
		displayName: 'Số phiếu',
		name: 'NUMBEROFBILL',
		alwaysChecked: false,
		isShow: true
	},
    {
		stt: 3,
		displayName: 'Tên tài liệu',
		name: 'NAME',
		alwaysChecked: false,
		isShow: true
	},
    {
		stt: 4,
		displayName: 'Tác giả',
		name: 'AUTHOR',
		alwaysChecked: false,
		isShow: true
	},
    {
		stt: 5,
		displayName: 'Giá mua',
		name: 'PRICE',
		alwaysChecked: false,
		isShow: true
	},
    {
		stt: 6,
		displayName: 'Trạng thái',
		name: 'STATUS',
		alwaysChecked: false,
		isShow: true
	},
	{
		stt: 7,
		displayName: 'Thao tác',
		name: 'ACTION',
		alwaysChecked: false,
		isShow: true
	},
    {
		stt: 8,
		displayName: 'Ngày đề nghị hoàn thành',
		name: 'DATE',
		alwaysChecked: false,
		isShow: true
	},
	{
		stt: 9,
		displayName: 'Người yêu cầu',
		name: 'CREATOR',
		alwaysChecked: false,
		isShow: true
	},
	{
		stt: 10,
		displayName: 'Bộ phận yêu cầu',
		name: 'ROOMREQUIRED',
		alwaysChecked: false,
		isShow: true
	}
]

export class RequiredToBuyList{
    id: number
    so_phieu: string
    ten_tai_lieu: string
    tac_gia: string
    gia_mua: number
    trang_thai_ma: string
    trang_thai_ten: string
    ngay_de_nghi_hoan_thanh: string
    nguoi_yeu_cau: string
    bo_phan_yeu_cau: string
    color: string
    clear(){
        this.id = 0
        this.so_phieu = ""
        this.ten_tai_lieu = ""
        this.tac_gia = ""
        this.gia_mua = 0
        this.trang_thai_ma = ""
        this.trang_thai_ten = ""
        this.ngay_de_nghi_hoan_thanh = ""
        this.nguoi_yeu_cau = ""
        this.bo_phan_yeu_cau = ""
        this.color = ""
    }
    copy(item: RequiredToBuyList){
        this.id = item.id
        this.so_phieu = item.so_phieu
        this.ten_tai_lieu = item.ten_tai_lieu
        this.tac_gia = item.tac_gia
        this.gia_mua = item.gia_mua
        this.trang_thai_ma = item.trang_thai_ma
        this.trang_thai_ten = item.trang_thai_ten
        this.ngay_de_nghi_hoan_thanh = item.ngay_de_nghi_hoan_thanh
        this.nguoi_yeu_cau = item.nguoi_yeu_cau
        this.bo_phan_yeu_cau = item.bo_phan_yeu_cau
        this.color = item.color
    }
}

export class RequiredToBuyEdit{
    id: number
    so_phieu: string
    ngay_lap_phieu: string
    nguoi_lap_phieu: string
    trang_thai_ma: string
    trang_thai_ten: string
    ten_tai_lieu: string
    loai_tai_lieu_id: number
    loai_tai_lieu_ten: string
    ngay_ban_hanh: string
    bo_phan_yeu_cau_id: number
    bo_phan_yeu_cau_ten: string
    nguoi_yeu_cau_id: number
    nguoi_yeu_cau_ten: string
    bptnbh_id: number[]
    bptnbh_ten: string[]
    ly_do_yeu_cau: string
    files: FileAttachment[]
    ma_tai_lieu: string
    lan_ban_hanh: string
    thoi_gian_ban_hanh: string
    bptnbh_id_ver2: number[]
    bptnbh_name_ver2: string[]
    confirms: RequiredToBuyConfirms[]

	loadInforManagerForm: boolean
	loadInforPresidentForm: boolean
	loadInforConfirmBuyForm: boolean
	loadInforConfirmUpdatedForm: boolean
    clear(){
        this.id = 0
        this.so_phieu = ""
        this.ngay_lap_phieu = ""
        this.nguoi_lap_phieu = ""
        this.trang_thai_ma = ""
        this.trang_thai_ten = ""
        this.ten_tai_lieu = ""
        this.loai_tai_lieu_id = 0
        this.loai_tai_lieu_ten = ""
        this.ngay_ban_hanh = ""
        this.bo_phan_yeu_cau_id = 0
        this.bo_phan_yeu_cau_ten = ""
        this.nguoi_yeu_cau_id = 0
        this.nguoi_yeu_cau_ten = ""
        this.bptnbh_id = []
        this.bptnbh_ten = []
        this.ly_do_yeu_cau = ""
        this.files = []
        this.ma_tai_lieu = ""
        this.lan_ban_hanh = ""
        this.thoi_gian_ban_hanh = ""
        this.bptnbh_id_ver2 = []
        this.bptnbh_name_ver2 = []
        this.confirms = []

		this.loadInforManagerForm = false;
		this.loadInforPresidentForm = false;
		this.loadInforConfirmBuyForm = false;
		this.loadInforConfirmUpdatedForm = false;
    }
    copy(item: RequiredToBuyEdit){
        this.id = item.id
        this.so_phieu = item.so_phieu
        this.ngay_lap_phieu = item.ngay_lap_phieu
        this.nguoi_lap_phieu = item.nguoi_lap_phieu
        this.trang_thai_ma = item.trang_thai_ma
        this.trang_thai_ten = item.trang_thai_ten
        this.ten_tai_lieu = item.ten_tai_lieu
        this.loai_tai_lieu_id = item.loai_tai_lieu_id
        this.loai_tai_lieu_ten = item.loai_tai_lieu_ten
        this.ngay_ban_hanh = item.ngay_ban_hanh
        this.bo_phan_yeu_cau_id = item.bo_phan_yeu_cau_id
        this.bo_phan_yeu_cau_ten = item.bo_phan_yeu_cau_ten
        this.nguoi_yeu_cau_id = item.nguoi_yeu_cau_id
        this.nguoi_yeu_cau_ten = item.nguoi_yeu_cau_ten
        this.bptnbh_id = item.bptnbh_id
        this.bptnbh_ten = item.bptnbh_ten
        this.ly_do_yeu_cau = item.ly_do_yeu_cau
        this.files = item.files
        this.ma_tai_lieu = item.ma_tai_lieu
        this.lan_ban_hanh = item.lan_ban_hanh
        this.thoi_gian_ban_hanh = item.thoi_gian_ban_hanh
        this.bptnbh_id_ver2 = item.bptnbh_id_ver2
        this.bptnbh_name_ver2 = item.bptnbh_name_ver2
        this.confirms = item.confirms

		this.loadInforManagerForm = item.loadInforManagerForm;
		this.loadInforPresidentForm = item.loadInforPresidentForm;
		this.loadInforConfirmBuyForm = item.loadInforConfirmBuyForm;
		this.loadInforConfirmUpdatedForm = item.loadInforConfirmUpdatedForm;
    }
}

export class RequiredToBuyConfirms{
    id : number
    id_yeu_cau_ban_hanh: number
    id_nguoi_duyet: number
    ten_nguoi_duyet: string
    ngay_duyet: string
    ly_do: string
    clear(){
        this.id = 0
        this.id_yeu_cau_ban_hanh = 0
        this.id_nguoi_duyet = 0
        this.ten_nguoi_duyet = ""
        this.ngay_duyet = ""
        this.ly_do = ""
    }
    copy(item: RequiredToBuyConfirms){
        this.id = item.id
        this.id_yeu_cau_ban_hanh = item.id_yeu_cau_ban_hanh
        this.id_nguoi_duyet = item.id_nguoi_duyet
        this.ten_nguoi_duyet = item.ten_nguoi_duyet
        this.ngay_duyet = item.ngay_duyet
        this.ly_do = item.ly_do
    }
}

export const StatusRequiredToBuy = [
    {
        id: 1,
        name: 'Đang soạn thảo',
        value: 'QLTL_YCM_DST',
        position: 1,
        show: true,
        checked: true
    },
    {
        id: 2,
        name: 'Chờ TP duyệt',
        value: 'QLTL_YCM_CTPD',
        position: 2,
        show: true,
        checked: true
    },
    {
        id: 3,
        name: 'Chờ GĐ duyệt',
        value: 'QLTL_YCM_CGDD',
        position: 3,
        show: true,
        checked: true
    },
    {
        id: 4,
        name: 'Chờ mua tài liệu',
        value: 'QLTL_YCM_CMTL',
        position: 4,
        show: true,
        checked: true
    },
    {
        id: 5,
        name: 'Chờ cập nhật tài liệu',
        value: 'QLTL_YCM_CUTL',
        position: 5,
        show: true,
        checked: true
    },
    {
        id: 6,
        name: 'Không duyệt',
        value: 'QLTL_YCM_KD',
        position: 6,
        show: true,
        checked: true
    },
    {
        id: 7,
        name: 'Hoàn tất',
        value: 'QLTL_YCM_HT',
        position: 7,
        show: true,
        checked: true
    }
]
